<template>
  <div class="Home">
    <div class="titlePage">{{this.$route.params.Area}}</div>
    <ShortPresen :InfoView="this.links"/>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ShortPresen from '@/components/dashboard/Shortcuts.vue'
import IberoHelpers from '@/store/helpers.js'

export default {
  name: 'Home',
  components: { ShortPresen },
  data () {
    return {
      links: [],
    }
  },
  methods: {
    callLoadMenu () {
      var linksData = IberoHelpers.getOperatorsReportsIcetexByUser(
        this.$store,
        this.$session.get('IberoJWTAdminLogin').idPerson,
      )
      linksData.then(Response => {
        console.log(Response.data)
        if (Response.data) {
          for (var i = 0; i < Response.data.length; i++) {
            Response.data[i] = {
              'id': 0,
              'title': Response.data[i].Nam_Operator,
              'link': Response.data[i].Url_Report,
              'target': '_blank',
              'show': true,
              'img': 'https://services.ibero.edu.co/Files/Operadores/FINANCIERA/Listado-de-estudiantes-en-credito-icetex.jpg',
            }
          }
          this.links = Response.data
        } else {
          this.links = []
        }
        IberoHelpers.forceRerender1(this)
      })
    },
  },
  created: function () {
    if (this.$session.get('IberoJWTAdminLogin').idPerson !== undefined) {
      this.callLoadMenu()
    } else {
      this.$session.remove('IberoJWTAdminLogin')
      this.$router.push({ name: 'not-found-simple' })
    }
  },
  computed: {
    ...mapState(['OperatorPresen']),
  },
}
</script>
